import { render, staticRenderFns } from "./PromotionQueryMenu.vue?vue&type=template&id=a74bd7a4&"
import script from "./PromotionQueryMenu.vue?vue&type=script&lang=js&"
export * from "./PromotionQueryMenu.vue?vue&type=script&lang=js&"
import style0 from "./PromotionQueryMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionQueryMenu.vue"
export default component.exports